// :cow: Cosmose CONFIDENTIAL :iso:
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, STATE_NAME } from '@coa/app/shared/add-to-group-dialog/modules/add-to-group/store/add-to-group.reducer';

const currentState = createFeatureSelector<State>(STATE_NAME);

export const selectShowSkeleton = createSelector(
  currentState,
  (state: State) => state.isLoading,
);

export const selectShowError = createSelector(
  currentState,
  (state: State) => state.isError,
);

export const selectShowEmpty = createSelector(
  currentState,
  (state: State) => state.groupsResponse?.length === 0,
);

export const selectShowList = createSelector(
  currentState,
  (state: State) => state.groupsResponse?.length > 0,
);

export const selectGroups = createSelector(
  currentState,
  (state: State) => state.groupsResponse,
);

export const selectIsAdding = createSelector(
  currentState,
  (state: State) => state.isAdding,
);

